module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Mehmet Kocer","short_name":"mkocer","start_url":"/","background_color":"#F1FFF2","theme_color":"#F1FFF2","display":"minimal-ui","icon":"src/images/mkocer-favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"85ad47e235f8763dbe47dcfb3b3f650c"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
